import React from "react";
import classes from "./FeaturesLayoutsTypeEighth.module.css"
import Features from "./Feature/FeaturesTypeEighth";

import {Col, Container, Row} from "reactstrap";

import {
    Assigment,
    Carousel,
    Dashboard, Extension,
    GooglePlay,
    Plus, RightArrow,
    Send,
    Star,
    Stats, Support,
    TimeLine
} from "../../../../components/Icons/Icons";
import Oval from "../../../../components/Frame/Frame";
import Slider from "./Slider/Slider";
import Slide from "./Slide/Slide";
import {Fade} from "react-awesome-reveal";

const title = "Comprehensive Biomedical Asset Management Software";
function MainFeature (props) {


    return (
        <React.Fragment>
            <section className={`section ${classes.features} ${(props.dark) ?  `dark ${classes.dark}` : ''}`}>

                <Container>
                    <Row className={classes.headerRow}>
                        <Col lg={9} md={9} >
                            <div className={classes.gridWrapper}>
                                <Fade top triggerOnce={true}>
                                    <h1 className={`title ${classes.title}`}>{title}</h1>
                                </Fade>
                            </div>
                        </Col>
                    </Row>

                    <Row className={classes.sliderRow}>
                        <Col className={`p-0 ${classes.col}`}>
                            <Slider>
                                <Slide>
                                    <Row className="flex-column">
                                        <Col className={`col-lg-12 ${classes.item}`}>
                                            <Fade down triggerOnce={true}>
                                            <Features
                                                title={"Asset Dashboard"}
                                                description={"Track assets, AMC due dates, PM & Calibration schedules, allocation, documentation etc. in one place"}
                                            >
                                                <Oval variant={"normal"}>
                                                    <Dashboard/>
                                                </Oval>
                                            </Features>
                                            </Fade>
                                        </Col>
                                        <Col className={`col-lg-12 ${classes.item}`}>
                                            <Fade down delay={50} triggerOnce={true}>
                                            <Features
                                                title={"Comprehensive Features"}
                                                description={"With Parts store, PM & Calibration Checklists, Daily Round logs, utilization, maintenance calendar, we have you covered."}>
                                                <Oval variant={"normal"}>
                                                    <Star/>
                                                </Oval>
                                            </Features>
                                            </Fade>
                                        </Col>
                                        <Col className={`col-lg-12 ${classes.item}`}>
                                            <Fade down delay={50} triggerOnce={true}>
                                                <Features
                                                  title={"Asset Transfer"}
                                                  description={"Track asset transfers to another department or group hospital. Preserve asset history."}>
                                                    <Oval variant={"normal"}>
                                                        <RightArrow />
                                                    </Oval>
                                                </Features>
                                            </Fade>
                                        </Col>
                                    </Row>
                                </Slide>
                                <Slide>
                                    <Row className="flex-column">
                                        <Col className={`col-lg-12 ${classes.item}`}>
                                            <Fade down delay={100} triggerOnce={true}>
                                            <Features
                                              title={"Incident Management"}
                                              description={"Incident tracking system with email and mobile app push notifications to reduce downtime."}
                                            >
                                                <Oval variant={"normal"}>
                                                    <Assigment/>
                                                </Oval>
                                            </Features>
                                            </Fade>
                                        </Col>
                                        <Col className={`col-lg-12 ${classes.item}`}>
                                            <Fade down delay={150} triggerOnce={true}>
                                            <Features
                                                title={"KPI Metrics"}
                                                description={"Track operational and financial metrics like MTTR, MTBR & service cost using our KPI dashboard."}>
                                                <Oval variant={"normal"}>
                                                    <Stats/>
                                                </Oval>
                                            </Features>
                                            </Fade>
                                        </Col>
                                        <Col className={`col-lg-12 ${classes.item}`}>
                                            <Fade down delay={50} triggerOnce={true}>
                                                <Features
                                                  title={"Supplier Collaboration"}
                                                  description={"Manage suppliers and service provider contacts. " +
                                                  "Notify service provider for incident support."}>
                                                    <Oval variant={"normal"}>
                                                        <Support />
                                                    </Oval>
                                                </Features>
                                            </Fade>
                                        </Col>
                                    </Row>
                                </Slide>
                                <Slide>
                                    <Row className="flex-column">
                                        <Col className={`col-lg-12 ${classes.item}`}>
                                            <Fade down delay={200} triggerOnce={true}>
                                            <Features
                                                title={"Service Logs"}
                                                description={"Maintain records of all maintenance activities, parts replaced and cost incurred. Assign service requests to team members."}
                                            >
                                                <Oval variant={"normal"}>
                                                    <Carousel/>
                                                </Oval>
                                            </Features>
                                            </Fade>
                                        </Col>
                                        <Col className={`col-lg-12 ${classes.item}`}>
                                            <Fade down delay={250} triggerOnce={true}>
                                            <Features
                                                title={"Mobile App"}
                                                description={"Native iOS and Android mobile app with bar code scanner enables biomedical teams to be productive on the move."}
                                            >
                                                <Oval variant={"normal"}>
                                                    <GooglePlay/>
                                                </Oval>
                                            </Features>
                                            </Fade>
                                        </Col>
                                        <Col className={`col-lg-12 ${classes.item}`}>
                                            <Fade down delay={50} triggerOnce={true}>
                                                <Features
                                                  title={"Extensible"}
                                                  description={"With APIs to integrate with other enterprise systems."}>
                                                    <Oval variant={"normal"}>
                                                        <Extension />
                                                    </Oval>
                                                </Features>
                                            </Fade>
                                        </Col>
                                    </Row>
                                </Slide>
                            </Slider>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    )
}
export default MainFeature
